export const appName = process.env.APP_NAME;
const date = process.env.RELEASE_DATE;
const branch = process.env.RELEASE_BRANCH;
const commit = process.env.RELEASE_COMMIT;

const populateRelease = () => {
  window.__APPS__ = window.__APPS__ || {};
  window.__APPS__[appName] = {
    date,
    branch,
    commit,
  };
};

export { populateRelease };
